module.exports = function(app) {
    app.filter('removeHtmlTags', function() {
        return function(string) {
            return string.replace(/<\/?[^>]+>/gi, '');
        };
    });
};
